export default {"src":"/_next/static/media/confusedWoman.8484f9cb.svg","height":280,"width":280,"blurWidth":0,"blurHeight":0};